import React, { Component } from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import {
  selectBrokerOpportunitiesLoading,
  selectLeadQueriesClicked,
  selectLeadQueriesSent,
  selectLeadQueriesSkipped,
  selectLeadQueriesWon,
  selectTeamAverageClickTime,
  selectTeamAverageSkipRate,
  selectTeamAverageWinTime,
  selectTotalAssigned
} from 'broker/selectors/broker_opportunities'

import { fetchBrokerOpportunitiesStats } from 'broker/redux/broker_opportunities'
import { wholeInteger, wholePercent, prettyTime, formatOrDash } from 'broker/util/helper'

import Card from 'broker/views/components/Card'
import RawCardSection from 'broker/views/components/CardSection'
import CardFlexingContentRow from 'broker/views/components/CardFlexingContentRow'
import RawCardDataPoint from 'broker/views/components/CardDataPoint'
import CardRow from 'broker/views/components/CardRow'

const CardDataPoint = connect(createStructuredSelector({
  loading: selectBrokerOpportunitiesLoading
}))(RawCardDataPoint)

const CardSection = connect(createStructuredSelector({
  loading: selectBrokerOpportunitiesLoading
}))(RawCardSection)

class BrokerPerformanceCard extends Component {
  componentDidMount() {
    this.props.fetchBrokerOpportunitiesStats()
  }

  render() {
    const {
      totalAssigned, leadQueriesSent, leadQueriesClicked, leadQueriesSkipped,
      leadQueriesWon, teamAverageClickTime, teamAverageSkipRate, teamAverageWinTime
    } = this.props

    return (
      <Card>
        <CardSection title="Opportunities" nopad>
          <CardRow>
            <CardFlexingContentRow>
              <CardDataPoint
                title="Assigned / Total Sent"
                value={`${formatOrDash(totalAssigned, wholeInteger)} / ${formatOrDash(leadQueriesSent, wholeInteger)}`}
              />
            </CardFlexingContentRow>
          </CardRow>
          <CardRow>
            <CardFlexingContentRow>
              <CardDataPoint
                title="Total Clicked"
                value={formatOrDash(leadQueriesClicked, wholeInteger)}
                small
              />
              <CardDataPoint
                title="Total Won"
                value={formatOrDash(leadQueriesWon, wholeInteger)}
                small
              />
            </CardFlexingContentRow>
            <CardFlexingContentRow>
              <CardDataPoint
                title="Total Skipped"
                value={formatOrDash(leadQueriesSkipped, wholeInteger)}
                small
              />
              <CardDataPoint
                title="Team Avg Skip Rate"
                value={formatOrDash(teamAverageSkipRate, wholePercent, { suffix: '%' })}
                small
              />
            </CardFlexingContentRow>
          </CardRow>
          <CardRow>
            <CardFlexingContentRow>
              <CardDataPoint
                title="Team Avg Click Time"
                value={formatOrDash(teamAverageClickTime, prettyTime)}
                small
              />
              <CardDataPoint
                title="Team Avg Win Time"
                value={formatOrDash(teamAverageWinTime, prettyTime)}
                small
              />
            </CardFlexingContentRow>
          </CardRow>
        </CardSection>
      </Card>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  totalAssigned: selectTotalAssigned,
  leadQueriesSent: selectLeadQueriesSent,
  leadQueriesClicked: selectLeadQueriesClicked,
  leadQueriesSkipped: selectLeadQueriesSkipped,
  leadQueriesWon: selectLeadQueriesWon,
  teamAverageClickTime: selectTeamAverageClickTime,
  teamAverageSkipRate: selectTeamAverageSkipRate,
  teamAverageWinTime: selectTeamAverageWinTime,
})

const mapDispatchToProps = dispatch => ({
  fetchBrokerOpportunitiesStats: () => dispatch(fetchBrokerOpportunitiesStats())
})

export default connect(mapStateToProps, mapDispatchToProps)(BrokerPerformanceCard)
